import { datalayers, defineDirective, groupByEquality, IDataLayerValue, LocaleString, models, sum } from "../../omnia"

    import Datalayer = datalayers.Datalayer
import { Chart } from "chart.js";

export class PerfDistributionCtrl {

    static create(): ng.IDirective {

        const def = defineDirective(PerfDistributionCtrl, undefined, {
            layer: "="
        })

        def.template = `<div><canvas width="295" height="200" style="width:295px;height:200px"></canvas></div>`

        def.link = (scope, element: ng.IAugmentedJQuery, attrs, ctrl: PerfDistributionCtrl) => ctrl.link(element);

        return def

    }


    private _rootElt: ng.IAugmentedJQuery

    private layer: Datalayer;
    private groups: { area: number, category: IDataLayerValue }[];

    private chart: Chart

    static $inject = ["$scope", "OmniaDatalayersService"];

    constructor(private $scope: ng.IScope) {
    }

    $onDestroy() {
        this.chart?.destroy()
        this.chart = undefined
    }

    private link(element: ng.IAugmentedJQuery) {
        this._rootElt = element
        this.setup()
    }

    private setup() {

        if (this._rootElt) {
            this.$scope.$watch("vm.layer", () => this.setupLayer())
        }

    }

    private setupLayer() {

        if (!this.layer) {
            return
        }

        this.chart?.destroy()

        var zones = this.layer.zones.map(z => ({
            area: z.area / 10000,
            category: <IDataLayerValue>z.value
        }));


        var groups = groupByEquality(zones, d => d.category).map(g => ({
            area: Math.round(sum(g.items, v => v.area) * 10) / 10,
            category: g.key
        }));

        this.groups = groups.sort((a, b) => {
            const va = a.category.Value
            const vb = b.category.Value
            return va > vb ? 1 : va < vb ? -1 : 0
        });

        var labels = [];
        var data = [];
        var colours = [];

        var totalArea = sum(this.groups, d => d.area);

        this.groups.forEach(d => {
            data.push(Math.round((d.area / totalArea) * 100));
            labels.push(d.category.Name);
            colours.push(omnia.color.colorToCss(this.layer.viewer.getValueFillColor(d.category), false));
        });

        const ctx = (this._rootElt[0].querySelector("canvas") as HTMLCanvasElement).getContext("2d");

        this.chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    data: data,
                    backgroundColor: colours,
                    label: 'Performance' as LocaleString,
                    borderColor: 'lightgray',
                    borderWidth: 1
                }]
            },
            options: {
                title: {
                    display: true,
                    text: 'Performance distribution by area' as LocaleString
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        title: () => undefined,
                        label: item => labels[item.index]
                    }
                },
                legend: {
                    display: false,
                    labels: {
                        fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif'
                    }
                },
                responsive: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            min: 0,
                            callback: value => {
                                return value + '%';
                            }
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            callback: (_, index) => groups[index].area + " ha"
                        }
                    }]
                }
            }
        });

    }

}
